var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"previous-step__container"},[_c('button',{staticClass:"previous-step__link",on:{"click":_vm.back}},[_vm._v("Back a step")])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7200ed7b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/cms-content-slices/components/clean-air-zone/PreviousStep.vue
// module id = T27l
// module chunks = 32